'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import BuildingAnExpertDispensaryController from './building-an-expert-dispensary.controller';
export default angular.module('eeComUiApp.buildingAnExpertDispensaryController', [ngMaterial])
    .controller('BuildingAnExpertDispensaryController', BuildingAnExpertDispensaryController)
    .name;
//# sourceMappingURL=index.js.map